import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'

/**
 * Fonts are self-hosted through @fontsource rather than loaded from Google's
 * CDN. On a German site that is not a preference: fetching a font from
 * fonts.googleapis.com transmits the visitor's IP to a third country, which
 * German courts have treated as a GDPR violation absent consent (LG München I,
 * 3 O 17493/20). Bundling them means the deployed site makes no third-party
 * requests at all - nothing to consent to, and no cookie banner needed.
 *
 * Both families are variable, so each is a single file covering every weight.
 */
import '@fontsource-variable/manrope'
import '@fontsource-variable/inter'

import './styles/tokens.css'
import './styles/base.css'
import './styles/layout.css'
import './styles/ui.css'
import './styles/pages.css'
import './styles/motion.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
